import { CrosshairsGpsIcon } from './CrosshairsGpsIcon';

/**
 * author: Google
 * id D3A1EC2E-98D5-46B6-BF33-DECBBAACEFBE
 * name crosshairs-gps
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/crosshairs-gps.svg
 * tags
 * - Navigation 
 * - Geographic Information System 
 */
export const GpsFixedIcon = CrosshairsGpsIcon;
export default GpsFixedIcon